/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * NXT48
 * API documentation generated from Zod schemas
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  UserAcceptMarketingConsent200,
  UserAcceptMarketingConsent400,
  UserAcceptMarketingConsentBody,
  UserAcceptTerms200,
  UserAcceptTerms400,
  UserAcceptTermsBody,
  UserCheckUsername200,
  UserCheckUsername400,
  UserCheckUsernameParams,
  UserClearDefaultBillingAddress200,
  UserClearDefaultBillingAddress400,
  UserClearDefaultDeliveryAddress200,
  UserClearDefaultDeliveryAddress400,
  UserClearTaxAddress200,
  UserClearTaxAddress400,
  UserCreateUserAddress200,
  UserCreateUserAddress400,
  UserCreateUserAddressBody,
  UserCreateUserSocialLink200,
  UserCreateUserSocialLink400,
  UserCreateUserSocialLinkBody,
  UserDeleteUserAddress200,
  UserDeleteUserAddress400,
  UserDeleteUserSocialLink200,
  UserDeleteUserSocialLink400,
  UserGetConsentStatus200,
  UserGetConsentStatus400,
  UserGetProfile200,
  UserGetProfile400,
  UserGetSecurityInfo200,
  UserGetSecurityInfo400,
  UserGetUserActivity200,
  UserGetUserActivity400,
  UserGetUserAddress200,
  UserGetUserAddress400,
  UserGetUserAddresses200Item,
  UserGetUserAddresses400,
  UserGetUserNotificationPreferences200Item,
  UserGetUserNotificationPreferences400,
  UserGetUserPreferences200,
  UserGetUserPreferences400,
  UserGetUserPrivacy200,
  UserGetUserPrivacy400,
  UserGetUserReferral200,
  UserGetUserReferral400,
  UserGetUserSocialLinks200Item,
  UserGetUserSocialLinks400,
  UserLinkAnonymousIdentity200,
  UserLinkAnonymousIdentity400,
  UserLinkAnonymousIdentityBody,
  UserRegisterDeviceToken200,
  UserRegisterDeviceToken400,
  UserRegisterDeviceTokenBody,
  UserSetDefaultBillingAddress200,
  UserSetDefaultBillingAddress400,
  UserSetDefaultDeliveryAddress200,
  UserSetDefaultDeliveryAddress400,
  UserSetTaxAddress200,
  UserSetTaxAddress400,
  UserUpdateProfile200,
  UserUpdateProfile400,
  UserUpdateProfileBody,
  UserUpdateReferralCode200,
  UserUpdateReferralCode400,
  UserUpdateReferralCodeBody,
  UserUpdateUserAddress200,
  UserUpdateUserAddress400,
  UserUpdateUserAddressBody,
  UserUpdateUserNotificationPreference200,
  UserUpdateUserNotificationPreference400,
  UserUpdateUserNotificationPreferenceBody,
  UserUpdateUserPreferences200,
  UserUpdateUserPreferences400,
  UserUpdateUserPreferencesBody,
  UserUpdateUserPrivacy200,
  UserUpdateUserPrivacy400,
  UserUpdateUserPrivacyBody,
  UserUpdateUserSocialLink200,
  UserUpdateUserSocialLink400,
  UserUpdateUserSocialLinkBody
} from '../nxt48.schemas';

import { customInstance } from '../../orval-fetcher';




/**
 * Get current user profile
 * @summary Get Profile
 */
export const userGetProfile = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserGetProfile200>(
      {url: `/user/profile`, method: 'GET', signal
    },
      );
    }
  



export const getUserGetProfileQueryKey = () => {
    return [
    `/user/profile`
    ] as const;
    }

    
export const getUserGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof userGetProfile>>, TError = UserGetProfile400 | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetProfile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetProfile>>> = ({ signal }) => userGetProfile(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof userGetProfile>>>
export type UserGetProfileQueryError = UserGetProfile400 | void


export function useUserGetProfile<TData = Awaited<ReturnType<typeof userGetProfile>>, TError = UserGetProfile400 | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetProfile>>,
          TError,
          Awaited<ReturnType<typeof userGetProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetProfile<TData = Awaited<ReturnType<typeof userGetProfile>>, TError = UserGetProfile400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetProfile>>,
          TError,
          Awaited<ReturnType<typeof userGetProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetProfile<TData = Awaited<ReturnType<typeof userGetProfile>>, TError = UserGetProfile400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetProfile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Profile
 */

export function useUserGetProfile<TData = Awaited<ReturnType<typeof userGetProfile>>, TError = UserGetProfile400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetProfile>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update current user profile
 * @summary Update Profile
 */
export const userUpdateProfile = (
    userUpdateProfileBody: UserUpdateProfileBody,
 ) => {
      
      
      return customInstance<UserUpdateProfile200>(
      {url: `/user/profile`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userUpdateProfileBody
    },
      );
    }
  


export const getUserUpdateProfileMutationOptions = <TError = UserUpdateProfile400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateProfile>>, TError,{data: UserUpdateProfileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userUpdateProfile>>, TError,{data: UserUpdateProfileBody}, TContext> => {

const mutationKey = ['userUpdateProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userUpdateProfile>>, {data: UserUpdateProfileBody}> = (props) => {
          const {data} = props ?? {};

          return  userUpdateProfile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserUpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof userUpdateProfile>>>
    export type UserUpdateProfileMutationBody = UserUpdateProfileBody
    export type UserUpdateProfileMutationError = UserUpdateProfile400 | void

    /**
 * @summary Update Profile
 */
export const useUserUpdateProfile = <TError = UserUpdateProfile400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateProfile>>, TError,{data: UserUpdateProfileBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userUpdateProfile>>,
        TError,
        {data: UserUpdateProfileBody},
        TContext
      > => {

      const mutationOptions = getUserUpdateProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Check if username is available
 * @summary Check Username Availability
 */
export const userCheckUsername = (
    params: UserCheckUsernameParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserCheckUsername200>(
      {url: `/username/check`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getUserCheckUsernameQueryKey = (params?: UserCheckUsernameParams,) => {
    return [
    `/username/check`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUserCheckUsernameQueryOptions = <TData = Awaited<ReturnType<typeof userCheckUsername>>, TError = UserCheckUsername400>(params: UserCheckUsernameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCheckUsername>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserCheckUsernameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userCheckUsername>>> = ({ signal }) => userCheckUsername(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userCheckUsername>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserCheckUsernameQueryResult = NonNullable<Awaited<ReturnType<typeof userCheckUsername>>>
export type UserCheckUsernameQueryError = UserCheckUsername400


export function useUserCheckUsername<TData = Awaited<ReturnType<typeof userCheckUsername>>, TError = UserCheckUsername400>(
 params: UserCheckUsernameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCheckUsername>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userCheckUsername>>,
          TError,
          Awaited<ReturnType<typeof userCheckUsername>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserCheckUsername<TData = Awaited<ReturnType<typeof userCheckUsername>>, TError = UserCheckUsername400>(
 params: UserCheckUsernameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCheckUsername>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userCheckUsername>>,
          TError,
          Awaited<ReturnType<typeof userCheckUsername>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserCheckUsername<TData = Awaited<ReturnType<typeof userCheckUsername>>, TError = UserCheckUsername400>(
 params: UserCheckUsernameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCheckUsername>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Check Username Availability
 */

export function useUserCheckUsername<TData = Awaited<ReturnType<typeof userCheckUsername>>, TError = UserCheckUsername400>(
 params: UserCheckUsernameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCheckUsername>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserCheckUsernameQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get all user addresses
 * @summary Get User Addresses
 */
export const userGetUserAddresses = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserGetUserAddresses200Item[]>(
      {url: `/user/addresses`, method: 'GET', signal
    },
      );
    }
  



export const getUserGetUserAddressesQueryKey = () => {
    return [
    `/user/addresses`
    ] as const;
    }

    
export const getUserGetUserAddressesQueryOptions = <TData = Awaited<ReturnType<typeof userGetUserAddresses>>, TError = UserGetUserAddresses400 | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserAddresses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserAddressesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUserAddresses>>> = ({ signal }) => userGetUserAddresses(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetUserAddresses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUserAddresses>>>
export type UserGetUserAddressesQueryError = UserGetUserAddresses400 | void


export function useUserGetUserAddresses<TData = Awaited<ReturnType<typeof userGetUserAddresses>>, TError = UserGetUserAddresses400 | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserAddresses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserAddresses>>,
          TError,
          Awaited<ReturnType<typeof userGetUserAddresses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserAddresses<TData = Awaited<ReturnType<typeof userGetUserAddresses>>, TError = UserGetUserAddresses400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserAddresses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserAddresses>>,
          TError,
          Awaited<ReturnType<typeof userGetUserAddresses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserAddresses<TData = Awaited<ReturnType<typeof userGetUserAddresses>>, TError = UserGetUserAddresses400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserAddresses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get User Addresses
 */

export function useUserGetUserAddresses<TData = Awaited<ReturnType<typeof userGetUserAddresses>>, TError = UserGetUserAddresses400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserAddresses>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserAddressesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new user address
 * @summary Create User Address
 */
export const userCreateUserAddress = (
    userCreateUserAddressBody: UserCreateUserAddressBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserCreateUserAddress200>(
      {url: `/user/addresses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userCreateUserAddressBody, signal
    },
      );
    }
  


export const getUserCreateUserAddressMutationOptions = <TError = UserCreateUserAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreateUserAddress>>, TError,{data: UserCreateUserAddressBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userCreateUserAddress>>, TError,{data: UserCreateUserAddressBody}, TContext> => {

const mutationKey = ['userCreateUserAddress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userCreateUserAddress>>, {data: UserCreateUserAddressBody}> = (props) => {
          const {data} = props ?? {};

          return  userCreateUserAddress(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserCreateUserAddressMutationResult = NonNullable<Awaited<ReturnType<typeof userCreateUserAddress>>>
    export type UserCreateUserAddressMutationBody = UserCreateUserAddressBody
    export type UserCreateUserAddressMutationError = UserCreateUserAddress400 | void

    /**
 * @summary Create User Address
 */
export const useUserCreateUserAddress = <TError = UserCreateUserAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreateUserAddress>>, TError,{data: UserCreateUserAddressBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userCreateUserAddress>>,
        TError,
        {data: UserCreateUserAddressBody},
        TContext
      > => {

      const mutationOptions = getUserCreateUserAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Clear default delivery address
 * @summary Clear Default Delivery Address
 */
export const userClearDefaultDeliveryAddress = (
    
 ) => {
      
      
      return customInstance<UserClearDefaultDeliveryAddress200>(
      {url: `/user/addresses/default-delivery`, method: 'DELETE'
    },
      );
    }
  


export const getUserClearDefaultDeliveryAddressMutationOptions = <TError = UserClearDefaultDeliveryAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClearDefaultDeliveryAddress>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userClearDefaultDeliveryAddress>>, TError,void, TContext> => {

const mutationKey = ['userClearDefaultDeliveryAddress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userClearDefaultDeliveryAddress>>, void> = () => {
          

          return  userClearDefaultDeliveryAddress()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserClearDefaultDeliveryAddressMutationResult = NonNullable<Awaited<ReturnType<typeof userClearDefaultDeliveryAddress>>>
    
    export type UserClearDefaultDeliveryAddressMutationError = UserClearDefaultDeliveryAddress400 | void

    /**
 * @summary Clear Default Delivery Address
 */
export const useUserClearDefaultDeliveryAddress = <TError = UserClearDefaultDeliveryAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClearDefaultDeliveryAddress>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userClearDefaultDeliveryAddress>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getUserClearDefaultDeliveryAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Clear default billing address
 * @summary Clear Default Billing Address
 */
export const userClearDefaultBillingAddress = (
    
 ) => {
      
      
      return customInstance<UserClearDefaultBillingAddress200>(
      {url: `/user/addresses/default-billing`, method: 'DELETE'
    },
      );
    }
  


export const getUserClearDefaultBillingAddressMutationOptions = <TError = UserClearDefaultBillingAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClearDefaultBillingAddress>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userClearDefaultBillingAddress>>, TError,void, TContext> => {

const mutationKey = ['userClearDefaultBillingAddress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userClearDefaultBillingAddress>>, void> = () => {
          

          return  userClearDefaultBillingAddress()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserClearDefaultBillingAddressMutationResult = NonNullable<Awaited<ReturnType<typeof userClearDefaultBillingAddress>>>
    
    export type UserClearDefaultBillingAddressMutationError = UserClearDefaultBillingAddress400 | void

    /**
 * @summary Clear Default Billing Address
 */
export const useUserClearDefaultBillingAddress = <TError = UserClearDefaultBillingAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClearDefaultBillingAddress>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userClearDefaultBillingAddress>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getUserClearDefaultBillingAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Clear tax address
 * @summary Clear Tax Address
 */
export const userClearTaxAddress = (
    
 ) => {
      
      
      return customInstance<UserClearTaxAddress200>(
      {url: `/user/addresses/tax`, method: 'DELETE'
    },
      );
    }
  


export const getUserClearTaxAddressMutationOptions = <TError = UserClearTaxAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClearTaxAddress>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userClearTaxAddress>>, TError,void, TContext> => {

const mutationKey = ['userClearTaxAddress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userClearTaxAddress>>, void> = () => {
          

          return  userClearTaxAddress()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserClearTaxAddressMutationResult = NonNullable<Awaited<ReturnType<typeof userClearTaxAddress>>>
    
    export type UserClearTaxAddressMutationError = UserClearTaxAddress400 | void

    /**
 * @summary Clear Tax Address
 */
export const useUserClearTaxAddress = <TError = UserClearTaxAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClearTaxAddress>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userClearTaxAddress>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getUserClearTaxAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get a specific user address
 * @summary Get User Address
 */
export const userGetUserAddress = (
    userAddressId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserGetUserAddress200>(
      {url: `/user/addresses/${userAddressId}`, method: 'GET', signal
    },
      );
    }
  



export const getUserGetUserAddressQueryKey = (userAddressId?: string,) => {
    return [
    `/user/addresses/${userAddressId}`
    ] as const;
    }

    
export const getUserGetUserAddressQueryOptions = <TData = Awaited<ReturnType<typeof userGetUserAddress>>, TError = UserGetUserAddress400 | void>(userAddressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserAddress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserAddressQueryKey(userAddressId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUserAddress>>> = ({ signal }) => userGetUserAddress(userAddressId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userAddressId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetUserAddress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserAddressQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUserAddress>>>
export type UserGetUserAddressQueryError = UserGetUserAddress400 | void


export function useUserGetUserAddress<TData = Awaited<ReturnType<typeof userGetUserAddress>>, TError = UserGetUserAddress400 | void>(
 userAddressId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserAddress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserAddress>>,
          TError,
          Awaited<ReturnType<typeof userGetUserAddress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserAddress<TData = Awaited<ReturnType<typeof userGetUserAddress>>, TError = UserGetUserAddress400 | void>(
 userAddressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserAddress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserAddress>>,
          TError,
          Awaited<ReturnType<typeof userGetUserAddress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserAddress<TData = Awaited<ReturnType<typeof userGetUserAddress>>, TError = UserGetUserAddress400 | void>(
 userAddressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserAddress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get User Address
 */

export function useUserGetUserAddress<TData = Awaited<ReturnType<typeof userGetUserAddress>>, TError = UserGetUserAddress400 | void>(
 userAddressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserAddress>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserAddressQueryOptions(userAddressId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a user address
 * @summary Update User Address
 */
export const userUpdateUserAddress = (
    userAddressId: string,
    userUpdateUserAddressBody: UserUpdateUserAddressBody,
 ) => {
      
      
      return customInstance<UserUpdateUserAddress200>(
      {url: `/user/addresses/${userAddressId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userUpdateUserAddressBody
    },
      );
    }
  


export const getUserUpdateUserAddressMutationOptions = <TError = UserUpdateUserAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserAddress>>, TError,{userAddressId: string;data: UserUpdateUserAddressBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserAddress>>, TError,{userAddressId: string;data: UserUpdateUserAddressBody}, TContext> => {

const mutationKey = ['userUpdateUserAddress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userUpdateUserAddress>>, {userAddressId: string;data: UserUpdateUserAddressBody}> = (props) => {
          const {userAddressId,data} = props ?? {};

          return  userUpdateUserAddress(userAddressId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserUpdateUserAddressMutationResult = NonNullable<Awaited<ReturnType<typeof userUpdateUserAddress>>>
    export type UserUpdateUserAddressMutationBody = UserUpdateUserAddressBody
    export type UserUpdateUserAddressMutationError = UserUpdateUserAddress400 | void

    /**
 * @summary Update User Address
 */
export const useUserUpdateUserAddress = <TError = UserUpdateUserAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserAddress>>, TError,{userAddressId: string;data: UserUpdateUserAddressBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userUpdateUserAddress>>,
        TError,
        {userAddressId: string;data: UserUpdateUserAddressBody},
        TContext
      > => {

      const mutationOptions = getUserUpdateUserAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Delete a user address
 * @summary Delete User Address
 */
export const userDeleteUserAddress = (
    userAddressId: string,
 ) => {
      
      
      return customInstance<UserDeleteUserAddress200>(
      {url: `/user/addresses/${userAddressId}`, method: 'DELETE'
    },
      );
    }
  


export const getUserDeleteUserAddressMutationOptions = <TError = UserDeleteUserAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userDeleteUserAddress>>, TError,{userAddressId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userDeleteUserAddress>>, TError,{userAddressId: string}, TContext> => {

const mutationKey = ['userDeleteUserAddress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userDeleteUserAddress>>, {userAddressId: string}> = (props) => {
          const {userAddressId} = props ?? {};

          return  userDeleteUserAddress(userAddressId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserDeleteUserAddressMutationResult = NonNullable<Awaited<ReturnType<typeof userDeleteUserAddress>>>
    
    export type UserDeleteUserAddressMutationError = UserDeleteUserAddress400 | void

    /**
 * @summary Delete User Address
 */
export const useUserDeleteUserAddress = <TError = UserDeleteUserAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userDeleteUserAddress>>, TError,{userAddressId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userDeleteUserAddress>>,
        TError,
        {userAddressId: string},
        TContext
      > => {

      const mutationOptions = getUserDeleteUserAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Set address as default delivery address
 * @summary Set Default Delivery Address
 */
export const userSetDefaultDeliveryAddress = (
    userAddressId: string,
 ) => {
      
      
      return customInstance<UserSetDefaultDeliveryAddress200>(
      {url: `/user/addresses/${userAddressId}/set-delivery`, method: 'PUT'
    },
      );
    }
  


export const getUserSetDefaultDeliveryAddressMutationOptions = <TError = UserSetDefaultDeliveryAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userSetDefaultDeliveryAddress>>, TError,{userAddressId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userSetDefaultDeliveryAddress>>, TError,{userAddressId: string}, TContext> => {

const mutationKey = ['userSetDefaultDeliveryAddress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userSetDefaultDeliveryAddress>>, {userAddressId: string}> = (props) => {
          const {userAddressId} = props ?? {};

          return  userSetDefaultDeliveryAddress(userAddressId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserSetDefaultDeliveryAddressMutationResult = NonNullable<Awaited<ReturnType<typeof userSetDefaultDeliveryAddress>>>
    
    export type UserSetDefaultDeliveryAddressMutationError = UserSetDefaultDeliveryAddress400 | void

    /**
 * @summary Set Default Delivery Address
 */
export const useUserSetDefaultDeliveryAddress = <TError = UserSetDefaultDeliveryAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userSetDefaultDeliveryAddress>>, TError,{userAddressId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userSetDefaultDeliveryAddress>>,
        TError,
        {userAddressId: string},
        TContext
      > => {

      const mutationOptions = getUserSetDefaultDeliveryAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Set address as default billing address
 * @summary Set Default Billing Address
 */
export const userSetDefaultBillingAddress = (
    userAddressId: string,
 ) => {
      
      
      return customInstance<UserSetDefaultBillingAddress200>(
      {url: `/user/addresses/${userAddressId}/set-billing`, method: 'PUT'
    },
      );
    }
  


export const getUserSetDefaultBillingAddressMutationOptions = <TError = UserSetDefaultBillingAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userSetDefaultBillingAddress>>, TError,{userAddressId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userSetDefaultBillingAddress>>, TError,{userAddressId: string}, TContext> => {

const mutationKey = ['userSetDefaultBillingAddress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userSetDefaultBillingAddress>>, {userAddressId: string}> = (props) => {
          const {userAddressId} = props ?? {};

          return  userSetDefaultBillingAddress(userAddressId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserSetDefaultBillingAddressMutationResult = NonNullable<Awaited<ReturnType<typeof userSetDefaultBillingAddress>>>
    
    export type UserSetDefaultBillingAddressMutationError = UserSetDefaultBillingAddress400 | void

    /**
 * @summary Set Default Billing Address
 */
export const useUserSetDefaultBillingAddress = <TError = UserSetDefaultBillingAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userSetDefaultBillingAddress>>, TError,{userAddressId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userSetDefaultBillingAddress>>,
        TError,
        {userAddressId: string},
        TContext
      > => {

      const mutationOptions = getUserSetDefaultBillingAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Set address as tax address
 * @summary Set Tax Address
 */
export const userSetTaxAddress = (
    userAddressId: string,
 ) => {
      
      
      return customInstance<UserSetTaxAddress200>(
      {url: `/user/addresses/${userAddressId}/set-tax`, method: 'PUT'
    },
      );
    }
  


export const getUserSetTaxAddressMutationOptions = <TError = UserSetTaxAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userSetTaxAddress>>, TError,{userAddressId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userSetTaxAddress>>, TError,{userAddressId: string}, TContext> => {

const mutationKey = ['userSetTaxAddress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userSetTaxAddress>>, {userAddressId: string}> = (props) => {
          const {userAddressId} = props ?? {};

          return  userSetTaxAddress(userAddressId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserSetTaxAddressMutationResult = NonNullable<Awaited<ReturnType<typeof userSetTaxAddress>>>
    
    export type UserSetTaxAddressMutationError = UserSetTaxAddress400 | void

    /**
 * @summary Set Tax Address
 */
export const useUserSetTaxAddress = <TError = UserSetTaxAddress400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userSetTaxAddress>>, TError,{userAddressId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userSetTaxAddress>>,
        TError,
        {userAddressId: string},
        TContext
      > => {

      const mutationOptions = getUserSetTaxAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get user preferences
 * @summary Get User Preferences
 */
export const userGetUserPreferences = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserGetUserPreferences200>(
      {url: `/user/preferences`, method: 'GET', signal
    },
      );
    }
  



export const getUserGetUserPreferencesQueryKey = () => {
    return [
    `/user/preferences`
    ] as const;
    }

    
export const getUserGetUserPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof userGetUserPreferences>>, TError = UserGetUserPreferences400 | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserPreferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserPreferencesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUserPreferences>>> = ({ signal }) => userGetUserPreferences(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetUserPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUserPreferences>>>
export type UserGetUserPreferencesQueryError = UserGetUserPreferences400 | void


export function useUserGetUserPreferences<TData = Awaited<ReturnType<typeof userGetUserPreferences>>, TError = UserGetUserPreferences400 | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserPreferences>>,
          TError,
          Awaited<ReturnType<typeof userGetUserPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserPreferences<TData = Awaited<ReturnType<typeof userGetUserPreferences>>, TError = UserGetUserPreferences400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserPreferences>>,
          TError,
          Awaited<ReturnType<typeof userGetUserPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserPreferences<TData = Awaited<ReturnType<typeof userGetUserPreferences>>, TError = UserGetUserPreferences400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get User Preferences
 */

export function useUserGetUserPreferences<TData = Awaited<ReturnType<typeof userGetUserPreferences>>, TError = UserGetUserPreferences400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserPreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update user preferences
 * @summary Update User Preferences
 */
export const userUpdateUserPreferences = (
    userUpdateUserPreferencesBody: UserUpdateUserPreferencesBody,
 ) => {
      
      
      return customInstance<UserUpdateUserPreferences200>(
      {url: `/user/preferences`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userUpdateUserPreferencesBody
    },
      );
    }
  


export const getUserUpdateUserPreferencesMutationOptions = <TError = UserUpdateUserPreferences400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserPreferences>>, TError,{data: UserUpdateUserPreferencesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserPreferences>>, TError,{data: UserUpdateUserPreferencesBody}, TContext> => {

const mutationKey = ['userUpdateUserPreferences'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userUpdateUserPreferences>>, {data: UserUpdateUserPreferencesBody}> = (props) => {
          const {data} = props ?? {};

          return  userUpdateUserPreferences(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserUpdateUserPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof userUpdateUserPreferences>>>
    export type UserUpdateUserPreferencesMutationBody = UserUpdateUserPreferencesBody
    export type UserUpdateUserPreferencesMutationError = UserUpdateUserPreferences400 | void

    /**
 * @summary Update User Preferences
 */
export const useUserUpdateUserPreferences = <TError = UserUpdateUserPreferences400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserPreferences>>, TError,{data: UserUpdateUserPreferencesBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userUpdateUserPreferences>>,
        TError,
        {data: UserUpdateUserPreferencesBody},
        TContext
      > => {

      const mutationOptions = getUserUpdateUserPreferencesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get user privacy settings
 * @summary Get User Privacy
 */
export const userGetUserPrivacy = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserGetUserPrivacy200>(
      {url: `/user/privacy`, method: 'GET', signal
    },
      );
    }
  



export const getUserGetUserPrivacyQueryKey = () => {
    return [
    `/user/privacy`
    ] as const;
    }

    
export const getUserGetUserPrivacyQueryOptions = <TData = Awaited<ReturnType<typeof userGetUserPrivacy>>, TError = UserGetUserPrivacy400 | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserPrivacy>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserPrivacyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUserPrivacy>>> = ({ signal }) => userGetUserPrivacy(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetUserPrivacy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserPrivacyQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUserPrivacy>>>
export type UserGetUserPrivacyQueryError = UserGetUserPrivacy400 | void


export function useUserGetUserPrivacy<TData = Awaited<ReturnType<typeof userGetUserPrivacy>>, TError = UserGetUserPrivacy400 | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserPrivacy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserPrivacy>>,
          TError,
          Awaited<ReturnType<typeof userGetUserPrivacy>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserPrivacy<TData = Awaited<ReturnType<typeof userGetUserPrivacy>>, TError = UserGetUserPrivacy400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserPrivacy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserPrivacy>>,
          TError,
          Awaited<ReturnType<typeof userGetUserPrivacy>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserPrivacy<TData = Awaited<ReturnType<typeof userGetUserPrivacy>>, TError = UserGetUserPrivacy400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserPrivacy>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get User Privacy
 */

export function useUserGetUserPrivacy<TData = Awaited<ReturnType<typeof userGetUserPrivacy>>, TError = UserGetUserPrivacy400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserPrivacy>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserPrivacyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update user privacy settings
 * @summary Update User Privacy
 */
export const userUpdateUserPrivacy = (
    userUpdateUserPrivacyBody: UserUpdateUserPrivacyBody,
 ) => {
      
      
      return customInstance<UserUpdateUserPrivacy200>(
      {url: `/user/privacy`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userUpdateUserPrivacyBody
    },
      );
    }
  


export const getUserUpdateUserPrivacyMutationOptions = <TError = UserUpdateUserPrivacy400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserPrivacy>>, TError,{data: UserUpdateUserPrivacyBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserPrivacy>>, TError,{data: UserUpdateUserPrivacyBody}, TContext> => {

const mutationKey = ['userUpdateUserPrivacy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userUpdateUserPrivacy>>, {data: UserUpdateUserPrivacyBody}> = (props) => {
          const {data} = props ?? {};

          return  userUpdateUserPrivacy(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserUpdateUserPrivacyMutationResult = NonNullable<Awaited<ReturnType<typeof userUpdateUserPrivacy>>>
    export type UserUpdateUserPrivacyMutationBody = UserUpdateUserPrivacyBody
    export type UserUpdateUserPrivacyMutationError = UserUpdateUserPrivacy400 | void

    /**
 * @summary Update User Privacy
 */
export const useUserUpdateUserPrivacy = <TError = UserUpdateUserPrivacy400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserPrivacy>>, TError,{data: UserUpdateUserPrivacyBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userUpdateUserPrivacy>>,
        TError,
        {data: UserUpdateUserPrivacyBody},
        TContext
      > => {

      const mutationOptions = getUserUpdateUserPrivacyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get user notification preferences
 * @summary Get User Notification Preferences
 */
export const userGetUserNotificationPreferences = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserGetUserNotificationPreferences200Item[]>(
      {url: `/user/notification-preferences`, method: 'GET', signal
    },
      );
    }
  



export const getUserGetUserNotificationPreferencesQueryKey = () => {
    return [
    `/user/notification-preferences`
    ] as const;
    }

    
export const getUserGetUserNotificationPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof userGetUserNotificationPreferences>>, TError = UserGetUserNotificationPreferences400 | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserNotificationPreferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserNotificationPreferencesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUserNotificationPreferences>>> = ({ signal }) => userGetUserNotificationPreferences(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetUserNotificationPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserNotificationPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUserNotificationPreferences>>>
export type UserGetUserNotificationPreferencesQueryError = UserGetUserNotificationPreferences400 | void


export function useUserGetUserNotificationPreferences<TData = Awaited<ReturnType<typeof userGetUserNotificationPreferences>>, TError = UserGetUserNotificationPreferences400 | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserNotificationPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserNotificationPreferences>>,
          TError,
          Awaited<ReturnType<typeof userGetUserNotificationPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserNotificationPreferences<TData = Awaited<ReturnType<typeof userGetUserNotificationPreferences>>, TError = UserGetUserNotificationPreferences400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserNotificationPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserNotificationPreferences>>,
          TError,
          Awaited<ReturnType<typeof userGetUserNotificationPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserNotificationPreferences<TData = Awaited<ReturnType<typeof userGetUserNotificationPreferences>>, TError = UserGetUserNotificationPreferences400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserNotificationPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get User Notification Preferences
 */

export function useUserGetUserNotificationPreferences<TData = Awaited<ReturnType<typeof userGetUserNotificationPreferences>>, TError = UserGetUserNotificationPreferences400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserNotificationPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserNotificationPreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a specific user notification preference
 * @summary Update User Notification Preference
 */
export const userUpdateUserNotificationPreference = (
    userUpdateUserNotificationPreferenceBody: UserUpdateUserNotificationPreferenceBody,
 ) => {
      
      
      return customInstance<UserUpdateUserNotificationPreference200>(
      {url: `/user/notification-preferences`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userUpdateUserNotificationPreferenceBody
    },
      );
    }
  


export const getUserUpdateUserNotificationPreferenceMutationOptions = <TError = UserUpdateUserNotificationPreference400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserNotificationPreference>>, TError,{data: UserUpdateUserNotificationPreferenceBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserNotificationPreference>>, TError,{data: UserUpdateUserNotificationPreferenceBody}, TContext> => {

const mutationKey = ['userUpdateUserNotificationPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userUpdateUserNotificationPreference>>, {data: UserUpdateUserNotificationPreferenceBody}> = (props) => {
          const {data} = props ?? {};

          return  userUpdateUserNotificationPreference(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserUpdateUserNotificationPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof userUpdateUserNotificationPreference>>>
    export type UserUpdateUserNotificationPreferenceMutationBody = UserUpdateUserNotificationPreferenceBody
    export type UserUpdateUserNotificationPreferenceMutationError = UserUpdateUserNotificationPreference400 | void

    /**
 * @summary Update User Notification Preference
 */
export const useUserUpdateUserNotificationPreference = <TError = UserUpdateUserNotificationPreference400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserNotificationPreference>>, TError,{data: UserUpdateUserNotificationPreferenceBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userUpdateUserNotificationPreference>>,
        TError,
        {data: UserUpdateUserNotificationPreferenceBody},
        TContext
      > => {

      const mutationOptions = getUserUpdateUserNotificationPreferenceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get all user social links
 * @summary Get User Social Links
 */
export const userGetUserSocialLinks = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserGetUserSocialLinks200Item[]>(
      {url: `/user/social-links`, method: 'GET', signal
    },
      );
    }
  



export const getUserGetUserSocialLinksQueryKey = () => {
    return [
    `/user/social-links`
    ] as const;
    }

    
export const getUserGetUserSocialLinksQueryOptions = <TData = Awaited<ReturnType<typeof userGetUserSocialLinks>>, TError = UserGetUserSocialLinks400 | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserSocialLinks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserSocialLinksQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUserSocialLinks>>> = ({ signal }) => userGetUserSocialLinks(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetUserSocialLinks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserSocialLinksQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUserSocialLinks>>>
export type UserGetUserSocialLinksQueryError = UserGetUserSocialLinks400 | void


export function useUserGetUserSocialLinks<TData = Awaited<ReturnType<typeof userGetUserSocialLinks>>, TError = UserGetUserSocialLinks400 | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserSocialLinks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserSocialLinks>>,
          TError,
          Awaited<ReturnType<typeof userGetUserSocialLinks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserSocialLinks<TData = Awaited<ReturnType<typeof userGetUserSocialLinks>>, TError = UserGetUserSocialLinks400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserSocialLinks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserSocialLinks>>,
          TError,
          Awaited<ReturnType<typeof userGetUserSocialLinks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserSocialLinks<TData = Awaited<ReturnType<typeof userGetUserSocialLinks>>, TError = UserGetUserSocialLinks400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserSocialLinks>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get User Social Links
 */

export function useUserGetUserSocialLinks<TData = Awaited<ReturnType<typeof userGetUserSocialLinks>>, TError = UserGetUserSocialLinks400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserSocialLinks>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserSocialLinksQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new user social link
 * @summary Create User Social Link
 */
export const userCreateUserSocialLink = (
    userCreateUserSocialLinkBody: UserCreateUserSocialLinkBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserCreateUserSocialLink200>(
      {url: `/user/social-links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userCreateUserSocialLinkBody, signal
    },
      );
    }
  


export const getUserCreateUserSocialLinkMutationOptions = <TError = UserCreateUserSocialLink400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreateUserSocialLink>>, TError,{data: UserCreateUserSocialLinkBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userCreateUserSocialLink>>, TError,{data: UserCreateUserSocialLinkBody}, TContext> => {

const mutationKey = ['userCreateUserSocialLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userCreateUserSocialLink>>, {data: UserCreateUserSocialLinkBody}> = (props) => {
          const {data} = props ?? {};

          return  userCreateUserSocialLink(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserCreateUserSocialLinkMutationResult = NonNullable<Awaited<ReturnType<typeof userCreateUserSocialLink>>>
    export type UserCreateUserSocialLinkMutationBody = UserCreateUserSocialLinkBody
    export type UserCreateUserSocialLinkMutationError = UserCreateUserSocialLink400 | void

    /**
 * @summary Create User Social Link
 */
export const useUserCreateUserSocialLink = <TError = UserCreateUserSocialLink400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreateUserSocialLink>>, TError,{data: UserCreateUserSocialLinkBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userCreateUserSocialLink>>,
        TError,
        {data: UserCreateUserSocialLinkBody},
        TContext
      > => {

      const mutationOptions = getUserCreateUserSocialLinkMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Update a user social link
 * @summary Update User Social Link
 */
export const userUpdateUserSocialLink = (
    id: string,
    userUpdateUserSocialLinkBody: UserUpdateUserSocialLinkBody,
 ) => {
      
      
      return customInstance<UserUpdateUserSocialLink200>(
      {url: `/user/social-links/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userUpdateUserSocialLinkBody
    },
      );
    }
  


export const getUserUpdateUserSocialLinkMutationOptions = <TError = UserUpdateUserSocialLink400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserSocialLink>>, TError,{id: string;data: UserUpdateUserSocialLinkBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserSocialLink>>, TError,{id: string;data: UserUpdateUserSocialLinkBody}, TContext> => {

const mutationKey = ['userUpdateUserSocialLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userUpdateUserSocialLink>>, {id: string;data: UserUpdateUserSocialLinkBody}> = (props) => {
          const {id,data} = props ?? {};

          return  userUpdateUserSocialLink(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserUpdateUserSocialLinkMutationResult = NonNullable<Awaited<ReturnType<typeof userUpdateUserSocialLink>>>
    export type UserUpdateUserSocialLinkMutationBody = UserUpdateUserSocialLinkBody
    export type UserUpdateUserSocialLinkMutationError = UserUpdateUserSocialLink400 | void

    /**
 * @summary Update User Social Link
 */
export const useUserUpdateUserSocialLink = <TError = UserUpdateUserSocialLink400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateUserSocialLink>>, TError,{id: string;data: UserUpdateUserSocialLinkBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userUpdateUserSocialLink>>,
        TError,
        {id: string;data: UserUpdateUserSocialLinkBody},
        TContext
      > => {

      const mutationOptions = getUserUpdateUserSocialLinkMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Delete a user social link
 * @summary Delete User Social Link
 */
export const userDeleteUserSocialLink = (
    id: string,
 ) => {
      
      
      return customInstance<UserDeleteUserSocialLink200>(
      {url: `/user/social-links/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getUserDeleteUserSocialLinkMutationOptions = <TError = UserDeleteUserSocialLink400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userDeleteUserSocialLink>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userDeleteUserSocialLink>>, TError,{id: string}, TContext> => {

const mutationKey = ['userDeleteUserSocialLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userDeleteUserSocialLink>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  userDeleteUserSocialLink(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserDeleteUserSocialLinkMutationResult = NonNullable<Awaited<ReturnType<typeof userDeleteUserSocialLink>>>
    
    export type UserDeleteUserSocialLinkMutationError = UserDeleteUserSocialLink400 | void

    /**
 * @summary Delete User Social Link
 */
export const useUserDeleteUserSocialLink = <TError = UserDeleteUserSocialLink400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userDeleteUserSocialLink>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userDeleteUserSocialLink>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getUserDeleteUserSocialLinkMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get user referral information
 * @summary Get User Referral
 */
export const userGetUserReferral = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserGetUserReferral200>(
      {url: `/user/referral`, method: 'GET', signal
    },
      );
    }
  



export const getUserGetUserReferralQueryKey = () => {
    return [
    `/user/referral`
    ] as const;
    }

    
export const getUserGetUserReferralQueryOptions = <TData = Awaited<ReturnType<typeof userGetUserReferral>>, TError = UserGetUserReferral400 | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserReferral>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserReferralQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUserReferral>>> = ({ signal }) => userGetUserReferral(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetUserReferral>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserReferralQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUserReferral>>>
export type UserGetUserReferralQueryError = UserGetUserReferral400 | void


export function useUserGetUserReferral<TData = Awaited<ReturnType<typeof userGetUserReferral>>, TError = UserGetUserReferral400 | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserReferral>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserReferral>>,
          TError,
          Awaited<ReturnType<typeof userGetUserReferral>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserReferral<TData = Awaited<ReturnType<typeof userGetUserReferral>>, TError = UserGetUserReferral400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserReferral>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserReferral>>,
          TError,
          Awaited<ReturnType<typeof userGetUserReferral>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserReferral<TData = Awaited<ReturnType<typeof userGetUserReferral>>, TError = UserGetUserReferral400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserReferral>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get User Referral
 */

export function useUserGetUserReferral<TData = Awaited<ReturnType<typeof userGetUserReferral>>, TError = UserGetUserReferral400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserReferral>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserReferralQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update user referral/discount code
 * @summary Update Referral Code
 */
export const userUpdateReferralCode = (
    userUpdateReferralCodeBody: UserUpdateReferralCodeBody,
 ) => {
      
      
      return customInstance<UserUpdateReferralCode200>(
      {url: `/user/referral-code`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userUpdateReferralCodeBody
    },
      );
    }
  


export const getUserUpdateReferralCodeMutationOptions = <TError = UserUpdateReferralCode400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateReferralCode>>, TError,{data: UserUpdateReferralCodeBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userUpdateReferralCode>>, TError,{data: UserUpdateReferralCodeBody}, TContext> => {

const mutationKey = ['userUpdateReferralCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userUpdateReferralCode>>, {data: UserUpdateReferralCodeBody}> = (props) => {
          const {data} = props ?? {};

          return  userUpdateReferralCode(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserUpdateReferralCodeMutationResult = NonNullable<Awaited<ReturnType<typeof userUpdateReferralCode>>>
    export type UserUpdateReferralCodeMutationBody = UserUpdateReferralCodeBody
    export type UserUpdateReferralCodeMutationError = UserUpdateReferralCode400 | void

    /**
 * @summary Update Referral Code
 */
export const useUserUpdateReferralCode = <TError = UserUpdateReferralCode400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateReferralCode>>, TError,{data: UserUpdateReferralCodeBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userUpdateReferralCode>>,
        TError,
        {data: UserUpdateReferralCodeBody},
        TContext
      > => {

      const mutationOptions = getUserUpdateReferralCodeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get user activity information
 * @summary Get User Activity
 */
export const userGetUserActivity = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserGetUserActivity200>(
      {url: `/user/activity`, method: 'GET', signal
    },
      );
    }
  



export const getUserGetUserActivityQueryKey = () => {
    return [
    `/user/activity`
    ] as const;
    }

    
export const getUserGetUserActivityQueryOptions = <TData = Awaited<ReturnType<typeof userGetUserActivity>>, TError = UserGetUserActivity400 | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserActivity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserActivityQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUserActivity>>> = ({ signal }) => userGetUserActivity(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetUserActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserActivityQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUserActivity>>>
export type UserGetUserActivityQueryError = UserGetUserActivity400 | void


export function useUserGetUserActivity<TData = Awaited<ReturnType<typeof userGetUserActivity>>, TError = UserGetUserActivity400 | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserActivity>>,
          TError,
          Awaited<ReturnType<typeof userGetUserActivity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserActivity<TData = Awaited<ReturnType<typeof userGetUserActivity>>, TError = UserGetUserActivity400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserActivity>>,
          TError,
          Awaited<ReturnType<typeof userGetUserActivity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserActivity<TData = Awaited<ReturnType<typeof userGetUserActivity>>, TError = UserGetUserActivity400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserActivity>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get User Activity
 */

export function useUserGetUserActivity<TData = Awaited<ReturnType<typeof userGetUserActivity>>, TError = UserGetUserActivity400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserActivity>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserActivityQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get user security information (safe data only - no passwords, secrets, or backup codes)
 * @summary Get User Security Info
 */
export const userGetSecurityInfo = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserGetSecurityInfo200>(
      {url: `/user/security`, method: 'GET', signal
    },
      );
    }
  



export const getUserGetSecurityInfoQueryKey = () => {
    return [
    `/user/security`
    ] as const;
    }

    
export const getUserGetSecurityInfoQueryOptions = <TData = Awaited<ReturnType<typeof userGetSecurityInfo>>, TError = UserGetSecurityInfo400 | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSecurityInfo>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetSecurityInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetSecurityInfo>>> = ({ signal }) => userGetSecurityInfo(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetSecurityInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetSecurityInfoQueryResult = NonNullable<Awaited<ReturnType<typeof userGetSecurityInfo>>>
export type UserGetSecurityInfoQueryError = UserGetSecurityInfo400 | void


export function useUserGetSecurityInfo<TData = Awaited<ReturnType<typeof userGetSecurityInfo>>, TError = UserGetSecurityInfo400 | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSecurityInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetSecurityInfo>>,
          TError,
          Awaited<ReturnType<typeof userGetSecurityInfo>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSecurityInfo<TData = Awaited<ReturnType<typeof userGetSecurityInfo>>, TError = UserGetSecurityInfo400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSecurityInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetSecurityInfo>>,
          TError,
          Awaited<ReturnType<typeof userGetSecurityInfo>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSecurityInfo<TData = Awaited<ReturnType<typeof userGetSecurityInfo>>, TError = UserGetSecurityInfo400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSecurityInfo>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get User Security Info
 */

export function useUserGetSecurityInfo<TData = Awaited<ReturnType<typeof userGetSecurityInfo>>, TError = UserGetSecurityInfo400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSecurityInfo>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetSecurityInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get current consent status for the authenticated user
 * @summary Get Consent Status
 */
export const userGetConsentStatus = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserGetConsentStatus200>(
      {url: `/user/consent`, method: 'GET', signal
    },
      );
    }
  



export const getUserGetConsentStatusQueryKey = () => {
    return [
    `/user/consent`
    ] as const;
    }

    
export const getUserGetConsentStatusQueryOptions = <TData = Awaited<ReturnType<typeof userGetConsentStatus>>, TError = UserGetConsentStatus400 | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetConsentStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetConsentStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetConsentStatus>>> = ({ signal }) => userGetConsentStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetConsentStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetConsentStatusQueryResult = NonNullable<Awaited<ReturnType<typeof userGetConsentStatus>>>
export type UserGetConsentStatusQueryError = UserGetConsentStatus400 | void


export function useUserGetConsentStatus<TData = Awaited<ReturnType<typeof userGetConsentStatus>>, TError = UserGetConsentStatus400 | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetConsentStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetConsentStatus>>,
          TError,
          Awaited<ReturnType<typeof userGetConsentStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetConsentStatus<TData = Awaited<ReturnType<typeof userGetConsentStatus>>, TError = UserGetConsentStatus400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetConsentStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetConsentStatus>>,
          TError,
          Awaited<ReturnType<typeof userGetConsentStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetConsentStatus<TData = Awaited<ReturnType<typeof userGetConsentStatus>>, TError = UserGetConsentStatus400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetConsentStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Consent Status
 */

export function useUserGetConsentStatus<TData = Awaited<ReturnType<typeof userGetConsentStatus>>, TError = UserGetConsentStatus400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetConsentStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetConsentStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Accept terms and conditions (for users who registered via OAuth/Wallet in medium/hard mode)
 * @summary Accept Terms
 */
export const userAcceptTerms = (
    userAcceptTermsBody: UserAcceptTermsBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserAcceptTerms200>(
      {url: `/user/consent/terms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userAcceptTermsBody, signal
    },
      );
    }
  


export const getUserAcceptTermsMutationOptions = <TError = UserAcceptTerms400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userAcceptTerms>>, TError,{data: UserAcceptTermsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userAcceptTerms>>, TError,{data: UserAcceptTermsBody}, TContext> => {

const mutationKey = ['userAcceptTerms'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userAcceptTerms>>, {data: UserAcceptTermsBody}> = (props) => {
          const {data} = props ?? {};

          return  userAcceptTerms(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserAcceptTermsMutationResult = NonNullable<Awaited<ReturnType<typeof userAcceptTerms>>>
    export type UserAcceptTermsMutationBody = UserAcceptTermsBody
    export type UserAcceptTermsMutationError = UserAcceptTerms400 | void

    /**
 * @summary Accept Terms
 */
export const useUserAcceptTerms = <TError = UserAcceptTerms400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userAcceptTerms>>, TError,{data: UserAcceptTermsBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userAcceptTerms>>,
        TError,
        {data: UserAcceptTermsBody},
        TContext
      > => {

      const mutationOptions = getUserAcceptTermsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Accept marketing consent
 * @summary Accept Marketing Consent
 */
export const userAcceptMarketingConsent = (
    userAcceptMarketingConsentBody: UserAcceptMarketingConsentBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserAcceptMarketingConsent200>(
      {url: `/user/consent/marketing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userAcceptMarketingConsentBody, signal
    },
      );
    }
  


export const getUserAcceptMarketingConsentMutationOptions = <TError = UserAcceptMarketingConsent400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userAcceptMarketingConsent>>, TError,{data: UserAcceptMarketingConsentBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userAcceptMarketingConsent>>, TError,{data: UserAcceptMarketingConsentBody}, TContext> => {

const mutationKey = ['userAcceptMarketingConsent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userAcceptMarketingConsent>>, {data: UserAcceptMarketingConsentBody}> = (props) => {
          const {data} = props ?? {};

          return  userAcceptMarketingConsent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserAcceptMarketingConsentMutationResult = NonNullable<Awaited<ReturnType<typeof userAcceptMarketingConsent>>>
    export type UserAcceptMarketingConsentMutationBody = UserAcceptMarketingConsentBody
    export type UserAcceptMarketingConsentMutationError = UserAcceptMarketingConsent400 | void

    /**
 * @summary Accept Marketing Consent
 */
export const useUserAcceptMarketingConsent = <TError = UserAcceptMarketingConsent400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userAcceptMarketingConsent>>, TError,{data: UserAcceptMarketingConsentBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userAcceptMarketingConsent>>,
        TError,
        {data: UserAcceptMarketingConsentBody},
        TContext
      > => {

      const mutationOptions = getUserAcceptMarketingConsentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Register a device token for push notifications
 * @summary Register Device Token
 */
export const userRegisterDeviceToken = (
    userRegisterDeviceTokenBody: UserRegisterDeviceTokenBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserRegisterDeviceToken200>(
      {url: `/user/device-tokens`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userRegisterDeviceTokenBody, signal
    },
      );
    }
  


export const getUserRegisterDeviceTokenMutationOptions = <TError = UserRegisterDeviceToken400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userRegisterDeviceToken>>, TError,{data: UserRegisterDeviceTokenBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userRegisterDeviceToken>>, TError,{data: UserRegisterDeviceTokenBody}, TContext> => {

const mutationKey = ['userRegisterDeviceToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userRegisterDeviceToken>>, {data: UserRegisterDeviceTokenBody}> = (props) => {
          const {data} = props ?? {};

          return  userRegisterDeviceToken(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserRegisterDeviceTokenMutationResult = NonNullable<Awaited<ReturnType<typeof userRegisterDeviceToken>>>
    export type UserRegisterDeviceTokenMutationBody = UserRegisterDeviceTokenBody
    export type UserRegisterDeviceTokenMutationError = UserRegisterDeviceToken400 | void

    /**
 * @summary Register Device Token
 */
export const useUserRegisterDeviceToken = <TError = UserRegisterDeviceToken400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userRegisterDeviceToken>>, TError,{data: UserRegisterDeviceTokenBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userRegisterDeviceToken>>,
        TError,
        {data: UserRegisterDeviceTokenBody},
        TContext
      > => {

      const mutationOptions = getUserRegisterDeviceTokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Link anonymous identity (clientId/fingerprint) to the authenticated user. Useful after OAuth login.
 * @summary Link Anonymous Identity
 */
export const userLinkAnonymousIdentity = (
    userLinkAnonymousIdentityBody: UserLinkAnonymousIdentityBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserLinkAnonymousIdentity200>(
      {url: `/user/link-identity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userLinkAnonymousIdentityBody, signal
    },
      );
    }
  


export const getUserLinkAnonymousIdentityMutationOptions = <TError = UserLinkAnonymousIdentity400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userLinkAnonymousIdentity>>, TError,{data: UserLinkAnonymousIdentityBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userLinkAnonymousIdentity>>, TError,{data: UserLinkAnonymousIdentityBody}, TContext> => {

const mutationKey = ['userLinkAnonymousIdentity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userLinkAnonymousIdentity>>, {data: UserLinkAnonymousIdentityBody}> = (props) => {
          const {data} = props ?? {};

          return  userLinkAnonymousIdentity(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserLinkAnonymousIdentityMutationResult = NonNullable<Awaited<ReturnType<typeof userLinkAnonymousIdentity>>>
    export type UserLinkAnonymousIdentityMutationBody = UserLinkAnonymousIdentityBody
    export type UserLinkAnonymousIdentityMutationError = UserLinkAnonymousIdentity400 | void

    /**
 * @summary Link Anonymous Identity
 */
export const useUserLinkAnonymousIdentity = <TError = UserLinkAnonymousIdentity400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userLinkAnonymousIdentity>>, TError,{data: UserLinkAnonymousIdentityBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userLinkAnonymousIdentity>>,
        TError,
        {data: UserLinkAnonymousIdentityBody},
        TContext
      > => {

      const mutationOptions = getUserLinkAnonymousIdentityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    